import { render, staticRenderFns } from "./shipping-method-item.vue?vue&type=template&id=db6387e6&"
import script from "./shipping-method-item.vue?vue&type=script&lang=js&"
export * from "./shipping-method-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports